<template>
    <div class="af" >
        <el-table
                v-loading="loading"
                border
                :data="tableData"
                class="el-child-table marT10"
                ref="table"
                size="mini"
                height="385"
                style="width: 100%"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
        >
            <el-table-column
                    align="center"
                    type="index"
                    label=""
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    v-if="i_isfrom==1"
                    prop="vc_fppzname"
                    :label="$t('invoiceEntry_invoice_item_name')"
                    show-overflow-tooltip
                    :width="i_fytype!=1?250:367">
                <template slot-scope="scope">
                    <span class="fppm">{{scope.row.vc_fppzname+' /'+$t('invoiceEntry_specification_model')+'：'+scope.row.vc_fpbzstyle+' /'+$t('form_unit')+'：'+scope.row.vc_fpunit+' /'+$t('form_quantity')+'：'+scope.row.f_fpnum+' /'+$t('form_unit_price')+'：'+scope.row.f_fpprice+' /'+$t('form_amount')+'：'+scope.row.f_fppay_ws+' /'+$t('invoiceEntry_tax_amount')+'：'+scope.row.f_fppay_zzs}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="vc_pzname"
                    :label="$t('form_product_name')"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.vc_pzname+' '+scope.row.vc_cd+scope.row.vc_gykh+scope.row.vc_bzstyle}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="f_glnum"
                    :label="$t('invoiceEntry_order_related_quantity')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="vc_no"
                    :label="$t('invoiceEntry_batch_order_number')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="i_isintransit"
                    :label="$t('invoiceEntry_system_prompt')"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <span :class="scope.row.i_isintransit==1?'red':''">{{scope.row.i_isintransit==1?$t('invoiceEntry_excess_order_quantity'):''}}</span>
                </template>
            </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer" style="text-align: center;padding: 6px">
            <el-button type="primary" @click="saveForm"  :class="baseerp+'btn'" size="small">{{$t('button_confirm')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>
<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import {baseApp} from "@/utils/baseUrl";
    import {file_url} from "@/utils/baseUrl";
    import {file_root} from "@/utils/baseUrl";
    import {baseVersion} from "@/utils/baseUrl";
    export default {
        name: "",
        components: {},
        props: {
            dataMx: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                i_flag:0,
                i_isfrom:1,
                i_fytype:0,
                baseerp: "",
                file_url: '',
                file_root:"",
                baseApp:"",
                baseVersion:"",
                loading:false,
                mid: 0,
                tableData: [],
                D_tableData:[],
                highlightCurrentRow: false,
            }
        },
        updated() {
            if(this.$refs.table && this.$refs.table.doLayout){
                this.$refs['table'].doLayout();
            }

        },
        mounted() {
            //this.getfMou();
            //console.log("sessionStorage.getItem('mids')",sessionStorage.getItem('mids'))
            //console.log("dataMx", this.dataMx);
            this.i_isfrom=this.dataMx.i_isfrom
            this.i_fytype=this.dataMx.i_fytype
            this.i_flag=this.dataMx.i_flag
            this.handleRelevancenum();
            this.baseerp = baseerp;
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.file_root = file_root;
            this.file=this.file_url;
            this.token=sessionStorage.getItem('token');
            this.i_uid=sessionStorage.getItem('userid');

            //demo2
            // 原始数组A（需分摊固定量的主体）
            const originalArrayA = [
                { id: "A1", f_num: 150, i_pzid: "X" },
                { id: "A2", f_num: 200, i_pzid: "Y" }
            ];
            // 原始数组B（资源池，使用深拷贝防止原始数据被修改）
            const originalArrayB = [
                { id: "B1", f_syglfpnum: 100, i_pzid: "X",i_over:1,f_glnum:0 },
                { id: "B2", f_syglfpnum: 200, i_pzid: "Y",i_over:0,f_glnum:0 }
            ];
            // 深拷贝B数组用于操作
            //const workingArrayB = JSON.parse(JSON.stringify(originalArrayB));
            //const processedArrayA = this.allocateFixedAmount(originalArrayA, workingArrayB);
            //console.log("处理后的数组A:", processedArrayA);
            //console.log("更新后的数组B:", JSON.stringify(workingArrayB, null, 2));
        },
        methods: {
            allocateFixedAmount(arrayA, arrayB) {
                // 创建类型映射加速检索（类型 → [B项列表]）
                const typeToBItems = arrayB.reduce((map, b) => {
                    map.set(b.i_pzid, (map.get(b.i_pzid) || []).concat(b));
                    return map;
                }, new Map());
                //console.log(typeToBItems,'typeToBItems')
                return arrayA.map(aItem => {
                    // 初始化分摊结果容器
                    const details = [];
                    let remaining = aItem.f_num;
                    const { i_pzid } = aItem;
                    let bItem_ = {};
                    // 获取匹配类型的B项（无匹配时返回空数组）
                    const matchedBItems = typeToBItems.get(i_pzid) || [];
                    //console.log(matchedBItems,'matchedBItems')
                    // 顺序分摊逻辑
                    for (const bItem of matchedBItems) {
                        if (remaining <= 0) break; // 提前终止条件
                        bItem_ = bItem;
                        const allocatable = Math.min(remaining, bItem.f_syglfpnum);
                        //console.log(allocatable,'allocatable')
                        if (allocatable > 0) {
                            // 记录分摊明细
                            details.push({
                                ...bItem,
                                //allocated: allocatable,
                                f_glnum:allocatable,
                                originalAvailable: bItem.f_syglfpnum // 保留原始可用量用于审计
                            });

                            // 更新剩余需求量和B项的可用量
                            remaining -= allocatable;
                            bItem.f_syglfpnum -= allocatable;
                        }
                    }
                    /*let map={};
                    let idx = matchedBItems.findIndex(item=>item.i_over==0)
                    console.log(idx,'idx')
                    if(idx!=-1){
                        map = matchedBItems[idx];
                    }else{
                        map = matchedBItems[0];
                        map.vc_no="";
                    }*/
                    // 补足逻辑（剩余需求量 > 0 时触发）
                    if (remaining > 0) {
                        let map={};
                        //map=aItem;
                        //map=bItem_
                        map.f_glnum=remaining.toFixed(this.$setPrecision.quantityPrecision);
                        map.i_isintransit=1;
                        map.isSupplement=true;
                        map.i_id=0;
                        map.i_pzid=i_pzid;
                        map.vc_pzname=bItem_.vc_pzname;
                        map.vc_cd=bItem_.vc_cd;
                        map.vc_gykh=bItem_.vc_gykh;
                        map.vc_bzsymbol=bItem_.vc_bzsymbol;
                        map.vc_bzstyle=bItem_.vc_bzstyle;
                        map.vc_unit=bItem_.vc_unit;
                        map.vc_kpname=bItem_.vc_kpname;
                        map.vc_no=bItem_.i_over==1?'':bItem_.vc_no;
                        details.push(
                            map
                            /*{
                            id: `SUPPLEMENT_${Date.now()}`,
                            i_pzid: "补足",
                            requiredAmount: remaining,
                            isSupplement: true
                            }*/
                        );
                    }
                    // 返回带分摊结果的新对象（不修改原始A项）
                    return {
                        ...aItem,
                        details,
                        fullyAllocated: remaining === 0
                    };
                });
            },


            //处理关联量
            handleRelevancenum(){
                let mul = this.dataMx.pzdetails.length;
                let tab = this.dataMx.data.length;
                //console.log(mul,'mul')
                //console.log(tab,'tab')
                if(mul>0){
                    let pzarr=this.deepClone(this.dataMx.pzdetails);
                    pzarr = pzarr.filter(item=>item.f_syglfpnum!=0)
                    //console.log(pzarr,'--');
                    let pzarr2=this.deepClone(pzarr);
                    //pzarr2.sort((a,b)=>b.f_syglfpnum - a.f_syglfpnum);
                    pzarr2.sort((a,b)=>new Date(a.dt_ordertime) - new Date(b.dt_ordertime));
                    //console.log(pzarr2,'---按时间排序');
                    let totalgl = 0;
                    pzarr2.map(item=>{
                            totalgl += item.f_syglfpnum;
                            item.f_syglfpnum2 = item.f_syglfpnum;
                            item.f_glnum = 0;
                    });
                    totalgl=parseFloat(this.keepTwoDecimal(totalgl));
                    //console.log('累计可关联量',totalgl);
                    let tabarr=this.deepClone(this.dataMx.data)
                        tabarr = tabarr.filter(item=>item.i_pzid!=0)
                    tabarr.map(item=>{
                        item.kyfpnum2=item.kyfpnum
                        let a = [];
                            a = pzarr2.filter(subitem=>{
                                return subitem.i_pzid == item.i_pzid
                            })
                        //item.details=a;//20250220
                    })
                    //console.log(tabarr,'tabarr-handle')
                    //console.log(pzarr2,'tpzarr2')
                    const processedArrayB= this.allocateFixedAmount(tabarr, pzarr2);
                    //console.log("处理后的数组B:", processedArrayB);
                    let data4 = this.deepClone(processedArrayB);
                    let newpzdetails4 =[];
                    data4.map(item=>{
                        item.details.map(subitem=>{
                            if(this.i_isfrom==1){
                                subitem.vc_fppzname=item.vc_fppzname
                                subitem.vc_fpbzstyle=item.vc_fpbzstyle
                                subitem.vc_fpunit=item.vc_fpunit
                                subitem.f_fpnum=item.f_fpnum
                                subitem.f_fpprice=item.f_fpprice
                                subitem.f_fppay_ws=item.f_fppay_ws
                                subitem.f_fppay_zzs=item.f_fppay_zzs
                                let bl =0;
                                if(item.kyfpnum==0){
                                    bl=0;
                                }else{
                                    //bl =  this.preciseDiv(item.f_fpnum, item.kyfpnum);
                                    bl =  this.preciseDiv(item.f_bcfpnum, item.f_num);
                                    bl = parseFloat(bl);
                                }
                                //console.log(bl,'bl====mx')
                                item.f_price_ws = bl*item.f_fpprice;
                                if(this.i_flag==1){
                                    //关税税率写死1%
                                    let gs =  item.f_num * item.f_price_ws * item.f_sl_gs
                                    gs = parseFloat(this.keepTwoDecimal(gs));
                                    item.f_pay_gs = gs;
                                    let payws = (item.f_num*item.f_price_ws)+item.f_pay_gs
                                    payws = parseFloat(this.keepTwoDecimal(payws));
                                    //item.f_pay_ws = payws;
                                    //console.log(payws,'payws')
                                    let more_ws = item.f_pay_ws+1;
                                    let less_ws = item.f_pay_ws-1;
                                    //console.log(more_ws,'more_ws');
                                    //console.log(less_ws,'less_ws');
                                    if(payws<less_ws||payws>more_ws){
                                        item.f_pay_ws = payws;
                                    }
                                    let fzzs = item.f_pay_ws * item.f_sl;
                                    fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                                    let more = item.f_pay_zzs+1;
                                    let less = item.f_pay_zzs-1;
                                    //console.log(more,'more');
                                    //console.log(less,'less');
                                    if(fzzs<less||fzzs>more){
                                        item.f_pay_zzs = fzzs;
                                    }
                                }else{
                                    item.f_price_ws = bl*item.f_fpprice
                                    let payws = item.f_num*item.f_price_ws
                                    payws = parseFloat(this.keepTwoDecimal(payws));
                                    //item.f_pay_ws = payws;
                                    //console.log(payws,'payws')
                                    let more_ws = item.f_pay_ws+1;
                                    let less_ws = item.f_pay_ws-1;
                                    //console.log(more_ws,'more_ws');
                                    //console.log(less_ws,'less_ws');
                                    if(payws<less_ws||payws>more_ws){
                                        item.f_pay_ws = payws;
                                    }
                                    let fzzs = item.f_pay_ws * item.f_sl;
                                    fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                                    let more = item.f_pay_zzs+1;
                                    let less = item.f_pay_zzs-1;
                                    //console.log(more,'more');
                                    //console.log(less,'less');
                                    if(fzzs<less||fzzs>more){
                                        item.f_pay_zzs = fzzs;
                                    }
                                }
                            }else{
                                /*item.f_price_ws = 0
                                let payws = item.f_num*item.f_price_ws
                                payws = parseFloat(this.keepTwoDecimal(payws));
                                item.f_pay_ws = payws;
                                let fzzs = item.f_pay_ws * item.f_sl;
                                fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                                item.f_pay_zzs = fzzs;*/
                            }
                            newpzdetails4.push(subitem)
                        })
                    })
                    //console.log(newpzdetails4,'newpzdetails4')
                    //console.log(data4,'data4')
                    this.tableData=newpzdetails4;
                    this.D_tableData=data4;
                    //this.plConnectnum(tabarr,pzarr2);
                }
            },
            //批量处理关联量
            plConnectnum(tab,pz){
                //console.log('批量')
                let data = this.deepClone(tab);
                data.map((item,index)=>{
                    let choopz = this.deepClone(item.details);
                    //console.log('item.i_pzid',item.i_pzid,'index',index,'choopz',choopz,item,'item')
                    let num = 0;
                    choopz.map(item=>{
                        num += item.f_syglfpnum2
                    })
                    //console.log(num,'num-可关联量和')
                    //console.log(item.f_num,'item.f_num-输入量')
                    if(num<item.f_num){
                        this.isbz=1
                        //console.log(1)
                        this.reduceQuantities(choopz,num)
                        //console.log(choopz,'choopz------1');
                        choopz.map((pzitem,index)=>{
                            pzitem.f_glnum = pzitem.f_syglfpnum2 - pzitem.f_syglfpnum;
                            pzitem.f_glnum = parseFloat(pzitem.f_glnum.toFixed(this.$setPrecision.quantityPrecision));;
                            pzitem.kyfpnum = item.kyfpnum;
                            item.kyfpnum2 = item.kyfpnum-pzitem.f_glnum;
                            pzitem.kyfpnum2 = item.kyfpnum2
                            pzitem.vc_fkey_sub = item.vc_fkey_sub
                        })
                        //console.log(choopz,'choopz2222222');
                        item.details=choopz;
                    }else{
                        this.isbz=1
                        //console.log(2)
                        this.reduceQuantities(choopz,item.f_num)
                        //console.log(choopz,'choopz------2');
                        let choopzC = this.deepClone(choopz)
                        choopzC.map((pzitem,index)=>{
                            pzitem.f_glnum = pzitem.f_syglfpnum2 - pzitem.f_syglfpnum;
                            pzitem.f_glnum = parseFloat(pzitem.f_glnum.toFixed(this.$setPrecision.quantityPrecision));
                            pzitem.kyfpnum = item.kyfpnum;
                            item.kyfpnum2 = item.kyfpnum-pzitem.f_glnum;
                            pzitem.kyfpnum2 = item.kyfpnum2
                            pzitem.vc_fkey_sub = item.vc_fkey_sub
                        })
                        //console.log(choopzC,'choopz2222222');
                        item.details=choopzC;
                    }

                })
                //console.log(data,'pltableData1')
                let newpzdetails = [];
                data.map(item=>{
                    item.details.map(subitem=>{
                        newpzdetails.push(subitem)
                    })
                })
                //console.log(newpzdetails,'newpzdetails')
                //判断newpzdetails是否存在相同品种和批次号
                let some = this.hassame(newpzdetails)
                //console.log(some);
                let newpzdetails2=[];
                /*if(this.isbz==1){
                    let pz1 =this.deepClone(pz)
                    let newpzdetailsC =this.deepClone(newpzdetails)
                    pz1.map(item=>{
                        let pzsub = [];
                        pzsub = newpzdetailsC.filter(subitem=>{
                            return subitem.i_pzid+subitem.vc_no == item.i_pzid+subitem.vc_no
                        })
                        console.log('-------------------')
                        console.log(pzsub,'pzsub')
                        if(pzsub.length>0){
                            let pzglnum = pzsub[0].f_syglfpnum2;
                            pzsub.map(pzitem=>{
                                pzitem.f_glnum2=pzitem.f_glnum
                                pzitem.f_glnum=0
                                pzitem.f_syglfpnum=pzitem.f_syglfpnum2
                            })
                            this.reduceQuantities(pzsub,pzglnum)
                            console.log(pzsub,'pzsub--')
                            pzsub.map(pzitem=>{
                                pzitem.f_glnum = pzitem.f_syglfpnum2 - pzitem.f_syglfpnum;
                                pzitem.f_glnum = parseFloat(this.keepTwoDecimal(pzitem.f_glnum));
                                pzitem.kyfpnum2 = pzitem.kyfpnum2+(pzitem.f_glnum2-pzitem.f_glnum);
                                newpzdetails2.push(pzitem)
                            })
                        }
                    })
                    console.log(newpzdetails2,'newpzdetails2----1')
                }else{
                    newpzdetails2=newpzdetails;
                    console.log(newpzdetails2,'newpzdetails2----2')
                }*/
                if(this.isbz==1){
                    let pz1 =this.deepClone(pz)
                    let newpzdetailsC =this.deepClone(newpzdetails)
                    pz1.map(item=>{
                        let pzsub = [];
                        pzsub = newpzdetailsC.filter(subitem=>{
                            return subitem.i_pzid+subitem.vc_no == item.i_pzid+item.vc_no
                        })
                        //console.log(pzsub,'pzsub')
                        if(pzsub.length>0){
                             let pzglnum = pzsub[0].f_syglfpnum2;
                            //相同品种批次号的和是否大于可关联
                             let sjnum = 0;
                            pzsub.map(subitem=>{
                                sjnum += subitem.f_glnum
                            })
                            //console.log(sjnum,'sjnum');
                            if(sjnum>pzglnum){
                                //console.log(sjnum+'>'+pzglnum)
                                pzsub.map((pzitem,pzindex)=>{
                                    pzitem.f_glnum2=pzitem.f_glnum
                                    pzitem.f_syglfpnum=pzitem.f_glnum
                                    pzitem.f_syglfpnum2=pzitem.f_glnum
                                    pzitem.f_glnum=0
                                    //pzitem.f_syglfpnum=pzitem.f_syglfpnum2

                                })
                                this.reduceQuantities(pzsub,pzglnum)
                                //console.log(pzsub,'pzsub--')
                                pzsub.map(pzitem=>{
                                    pzitem.f_glnum = pzitem.f_syglfpnum2 - pzitem.f_syglfpnum;
                                    pzitem.f_glnum = parseFloat(pzitem.f_glnum.toFixed(this.$setPrecision.quantityPrecision));
                                    pzitem.kyfpnum2 = pzitem.kyfpnum2+(pzitem.f_glnum2-pzitem.f_glnum);
                                    newpzdetails2.push(pzitem)
                                })
                            }else{
                                //this.reduceQuantities(pzsub,sjnum)
                                //console.log(pzsub,'pzsub--')
                                pzsub.map(pzitem=>{
                                    newpzdetails2.push(pzitem)
                                })
                            }
                        }
                    })
                    //console.log(newpzdetails2,'newpzdetails2----1')
                }else{
                    newpzdetails2=newpzdetails;
                    //console.log(newpzdetails2,'newpzdetails2----2')
                }

                /*//发票关联量不足是否可以补足
                let newpzdetailsCC =this.deepClone(newpzdetails2)
                let sub = [];
                sub = newpzdetailsCC.filter(subitem=>{
                    return subitem.vc_fkey_sub == subitem.vc_fkey_sub
                })
                console.log(sub,'sub')
                if(sub.length>0){
                    let fpnum = sub[0].kyfpnum;
                    //相同发票和是否不足发票量
                    let sjnum = 0;
                    sub.map(subitem=>{
                        sjnum += subitem.f_glnum
                    })
                    console.log(sjnum,'sjnum');
                    if(sjnum<fpnum){
                        console.log(sjnum+'<'+fpnum)
                        let qsnum = fpnum - sjnum
                            qsnum = parseFloat(this.keepTwoDecimal(qsnum));
                        console.log('qsnum----',qsnum)
                        sub = sub.filter(item=>item.f_glnum!=0&&item.f_syglfpnum!=0)
                        console.log(sub,'sub-')
                        sub.map(subitem=>{
                            let num = subitem.f_glnum + qsnum
                                num = parseFloat(this.keepTwoDecimal(num));
                            sunitem.num =num
                        })
                        let numidx = sub.findIndex(item=>{
                            return item.num<item.f_syglfpnum
                        })
                        console.log(numidx,'numidx')
                        if(numidx!=-1){
                            sub[numidx].f_glnum=sub[numidx].num
                        }
                        newpzdetailsCC=[...sub,...newpzdetailsCC]
                    }
                }
                console.log(newpzdetailsCC,'newpzdetailsCC')*/


                let newpzdetails3 = [];
                if(this.i_isfrom==1){
                    //根据发票key分组
                    let fparr=[];
                    newpzdetails2.map(mapitem=>{
                        if(fparr.length==0){
                            fparr.push({vc_fkey_sub:mapitem.vc_fkey_sub,list:[mapitem]})
                        }else{
                            let res = fparr.some(item=>{
                                if(item.vc_fkey_sub == mapitem.vc_fkey_sub){
                                    item.list.push(mapitem)
                                    return true
                                }
                            })
                            if(!res){
                                fparr.push({vc_fkey_sub:mapitem.vc_fkey_sub,list:[mapitem]}
                                )
                            }
                        }
                    });
                    //console.log("fparr",fparr);
                    let fparr2 = this.deepClone(fparr)
                    fparr2.map(mapitem=>{
                        mapitem.kyfpnum=mapitem.list[0].kyfpnum;
                        let inglnum=0;
                        mapitem.list.map(listitem=>{
                            inglnum += listitem.f_glnum
                        })
                        mapitem.inglnum=inglnum
                    })
                    //console.log("fparr2",fparr2);

                    /*//根据品种批次号分组
                    let glarr=[];
                    newpzdetails2.map(mapitem=>{
                        if(glarr.length==0){
                            glarr.push({vc_no:mapitem.vc_no,list:[mapitem]})
                        }else{
                            let res = glarr.some(item=>{
                                if(item.vc_no == mapitem.vc_no){
                                    item.list.push(mapitem)
                                    return true
                                }
                            })
                            if(!res){
                                glarr.push({vc_no:mapitem.vc_no,list:[mapitem]}
                                )
                            }
                        }
                    });
                    console.log("glarr",glarr);
                    glarr.map(item=>{
                        let glnum = 0
                        let yynum = 0
                        item.list.map(listmap=>{
                            yynum += listmap.f_glnum
                        })
                        item.glnum = listmap[0].f_syglfpnum2
                    })
                    let fparr3 = this.deepClone(fparr2)
                    fparr3.map(item=>{
                        let inglnum = parseFloat(this.keepTwoDecimal(item.inglnum));
                        let kyfpnum = parseFloat(this.keepTwoDecimal(item.kyfpnum));
                        if(inglnum<kyfpnum){
                            //找是否有关联量没用完
                            item = item.list.filter(item=>item.f_glnum!=0&&item.f_syglfpnum!=0)
                            console.log(item,'item')
                            if(item.length>0){
                                item.map(subitem=>{
                                    let noarr = glarr.filter(glitem=>{
                                        return glitem.vc_no == subitem.vc_no
                                    })
                                    console.log(noarr,'noarr')

                                })
                            }
                        }
                    })*/

                    //补足发票剩余量
                    let extra=[];
                    fparr2.map(item=>{
                        let sy = item.kyfpnum - item.inglnum
                        sy = parseFloat(sy.toFixed(this.$setPrecision.quantityPrecision))
                        if(sy>0){
                            let idx = item.list.findIndex(listitem=>{
                                return listitem.i_over == 0
                            })
                            let map={};
                            if(idx==-1){
                                map=this.deepClone(item.list[0]);
                                map.f_glnum=sy;
                                map.vc_no='';
                                map.i_isintransit=1;
                            }else{
                                map=this.deepClone(item.list[idx]);
                                map.f_glnum=sy;
                                map.i_isintransit=1;
                            }
                            extra.push(map);
                        }
                    })
                    //console.log(extra,'extra')

                    newpzdetails3 = newpzdetails2.concat(extra)
                    //console.log(newpzdetails3,'newpzdetails3');
                }else{
                    newpzdetails3 = this.deepClone(newpzdetails2)
                }
                //console.log(newpzdetails3,'newpzdetails3')
                //把处理好的关联量塞回对应外层
                let data3 = this.deepClone(data)
                //console.log(data3,'data3')
                data3.map(item=>{
                    let son = [];
                        son = newpzdetails3.filter(subitem=>{
                            if(this.i_isfrom==1){
                                return subitem.vc_fkey_sub+subitem.i_pzid == item.vc_fkey_sub+item.i_pzid && subitem.f_glnum!=0
                            }else{
                                return subitem.i_pzid == item.i_pzid && subitem.f_glnum!=0
                            }
                        })
                    //console.log(son,'son')
                    item.details=son;
                    let fnum = 0;
                    if(item.details.length>0){
                        item.details.map(subitem=>{
                            fnum += subitem.f_glnum;
                            item.f_num = fnum;
                            item.kyfpnum2 = item.kyfpnum - item.f_num
                        })
                    }else{
                        item.f_num=0;
                        item.kyfpnum2 = item.kyfpnum - item.f_num
                    }
                })
                //console.log(data3,'data3')
                //过滤掉f_num==0&&组织三层数据
                let data4 = this.deepClone(data3);
                data4 = data4.filter(item=>item.f_num!=0||item.f_fpnum==0)
                //console.log(data4,'data4--')
                let newpzdetails4 =[];
                data4.map(item=>{
                    item.details.map(subitem=>{
                        if(this.i_isfrom==1){
                            subitem.vc_fppzname=item.vc_fppzname
                            subitem.vc_fpbzstyle=item.vc_fpbzstyle
                            subitem.vc_fpunit=item.vc_fpunit
                            subitem.f_fpnum=item.f_fpnum
                            subitem.f_fpprice=item.f_fpprice
                            subitem.f_fppay_ws=item.f_fppay_ws
                            subitem.f_fppay_zzs=item.f_fppay_zzs
                            let bl =0;
                            if(item.kyfpnum==0){
                                bl=0;
                            }else{
                                bl =  this.preciseDiv(item.f_fpnum, item.kyfpnum);
                                bl = parseFloat(bl);
                            }
                            //console.log(bl,'bl====mx')
                            item.f_price_ws = bl*item.f_fpprice;
                            if(this.i_flag==1){
                                //关税税率写死1%
                                let gs =  item.f_num * item.f_price_ws * item.f_sl_gs
                                gs = parseFloat(this.keepTwoDecimal(gs));
                                item.f_pay_gs = gs;
                                let payws = (item.f_num*item.f_price_ws)+item.f_pay_gs
                                payws = parseFloat(this.keepTwoDecimal(payws));
                                item.f_pay_ws = payws;
                                let fzzs = item.f_pay_ws * item.f_sl;
                                fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                                let more = item.f_pay_zzs+1;
                                let less = item.f_pay_zzs-1;
                                //console.log(more,'more');
                                //console.log(less,'less');
                                if(fzzs<less||fzzs>more){
                                    item.f_pay_zzs = fzzs;
                                }
                            }else{
                                item.f_price_ws = bl*item.f_fpprice
                                let payws = item.f_num*item.f_price_ws
                                payws = parseFloat(this.keepTwoDecimal(payws));
                                item.f_pay_ws = payws;
                                let fzzs = item.f_pay_ws * item.f_sl;
                                fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                                let more = item.f_pay_zzs+1;
                                let less = item.f_pay_zzs-1;
                                //console.log(more,'more');
                                //console.log(less,'less');
                                if(fzzs<less||fzzs>more){
                                    item.f_pay_zzs = fzzs;
                                }
                            }
                        }else{
                            /*item.f_price_ws = 0
                            let payws = item.f_num*item.f_price_ws
                            payws = parseFloat(this.keepTwoDecimal(payws));
                            item.f_pay_ws = payws;
                            let fzzs = item.f_pay_ws * item.f_sl;
                            fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                            item.f_pay_zzs = fzzs;*/
                        }
                        newpzdetails4.push(subitem)
                    })
                })
                //console.log(newpzdetails4,'newpzdetails4')
                //console.log(data4,'data4')
                this.tableData=newpzdetails4;
                this.D_tableData=data4;
            },
            saveForm(){
                let map={
                    data:this.D_tableData,
                };
                this.$emit('cancelDialog_mx',map);
            },
            hassame(arr){
              const seen = new Set();
              return arr.some(item=>{
                  const itemStr = JSON.stringify(item);
                  return seen.has(itemStr) || seen.add(itemStr)
              })
            },
            reduceQuantities(items, total) {
                //console.log(items,'items',total,'total')
                while (total > 0) {
                    for (let i = 0; i < items.length; i++) {
                        if (items[i].f_syglfpnum  > 0) {
                            //console.log(i,'i')
                            //console.log(items[i].f_syglfpnum,'items[i].f_num')
                            //console.log(total,'total')
                            total = parseFloat((total - items[i].f_syglfpnum).toFixed(this.$setPrecision.quantityPrecision)) ;
                            //console.log(total,'total')
                            if(total>0){
                                items[i].f_syglfpnum=0;
                                //console.log(items[i].f_syglfpnum,'items[i].f_syglfpnum')
                                //console.log(total,'total>0')
                            }
                            if (total === 0) {
                                items[i].f_syglfpnum=0;
                                //console.log(items[i].f_syglfpnum,'items[i].f_syglfpnum')
                                //console.log(total,'total === 0')
                                break;
                            }
                            if (total < 0) {
                                items[i].f_syglfpnum=total*-1;
                                //console.log(items[i].f_syglfpnum,'items[i].f_syglfpnum')
                                //console.log(total,'total < 0')
                                break;
                            }
                            //console.log(total,'-------')
                            break;
                            // 继续下一轮减少
                        }
                    }
                }
            },
            deepClone(source) {
                if (typeof source !== 'object' || source == null) {
                    return source;
                }
                const target = Array.isArray(source) ? [] : {};
                for (const key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        if (typeof source[key] === 'object' && source[key] !== null) {
                            target[key] = this.deepClone(source[key]);
                        } else {
                            target[key] = source[key];
                        }
                    }
                }
                return target;
            },
            keepTwoDecimal(num) {
                var result = parseFloat(num);
                if (isNaN(result)) {
                    result = 0;
                }else{
                    result = Math.round(num * 100) / 100;//保留两位
                }
                return result;
            },
            //除
            preciseDiv(dividend, divisor) {
                if(dividend&&divisor){
                    //console.log(dividend,"////",divisor);
                    // 将除数和被除数转换为整数
                    const intDividend = parseFloat(dividend * 1000);
                    const intDivisor = parseFloat(divisor * 1000);
                    // 执行除法
                    const result = intDividend / intDivisor;
                    //console.log(result,'result------')
                    return result ;
                }
            },
            refreshTable(){
                this.showTable=false;
                this.$nextTick(()=>{
                    this.showTable=true;
                })
            },
            cancel(){
                this.$emit('cancelDialog_mx');
            },

        }
    }
</script>
<style>
    .el-message-box__message p{
        max-height: 500px !important;
        overflow-y: auto !important;
    }
</style>
<style  lang="scss" scoped>
    .fppm{
        max-height: 40px; /* 根据需要设置占位的行高 × 行数 */
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        display: -webkit-box;
        -webkit-line-clamp: 2; /* 显示的行数 */
        -webkit-box-orient: vertical;
    }

    /deep/ .el-table th{
            //text-align: left !important;
        }

    /deep/.el-child-table .el-table__body-wrapper{
        width: 100% !important;
    }
    /deep/.el-table__expanded-cell{
        padding: 3px 3px 3px 48px;
    }
    /*.has-child {
        padding: 0px !important;
        // display: none;
        & > .cell {
            padding: 0 !important;
        }
        ::before {
            height: 0;
        }
        .child-table {
            background-color: transparent;
            .cell{
                line-height: 34px;
            }
        }
        .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
            background-color: transparent;
        }
        .el-table__body tr.current-row > td.el-table__cell,
        .el-table__body tr.selection-row > td.el-table__cell {
            background-color: transparent;
        }
        tr {
            background-color: transparent;
        }
        .child-head {
            display: flex!important;
        }
        /deep/.el-table .el-table__cell{
            padding: 0;
        }
        /deep/.el-table .cell{
            line-height: 34px;
        }
    }*/
    .green{
        color: #67c23a;
    }
    .orange{
        color: #e6a23c;
    }
    .gray{
        color: #909399;
    }
    .red{
        color: #f56c6c !important;
    }

    /deep/.el-table td{
        //text-align: center !important;
    }
    .txtE{
        text-align: end;
    }
    .marl4{
        margin-left: 4px;
    }
    /deep/.red .el-input--mini .el-input__inner{
        color: red !important;
    }
    .red{
        color: red !important;
    }

    /*/deep/.el-table--scrollable-x .el-table__body-wrapper{
        height:195px !important;
    }*/
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        width: 90px;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
        background: #eef1f6;
    }

    .popaddbtn{
        border: none;
        padding: 0;
    }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .w20{
        width: 20%;
    }
    .blue{
        color: #3e83e8 !important;
    }
    .red{
        color: red !important;
    }
    .tw11{
        width: 11%;
    }
    .mart9{
        margin-top: 9px;
    }
    .martb5{
        margin: 9px 0px;
    }
    .txt{
        text-align: center;
    }
    .pad35_25{
        padding: 35px 25px;
    }
    .padB5{
        padding-bottom: 5px;
    }
    .marT10{
        margin-top: 10px;
    }
    .pad15_25{
        padding: 0px 25px;
    }
    .w100{
        width: 100%;
    }
    .w33{
        width: 33%;
    }
    .w50{
        width: 50%;
    }
    .borderB{
        border-bottom: 1px solid #e1e1e1;
    }
    .alc{
        align-items: center;
    }
    .font14_t{
        font-size: 16px;
        color: black;
        min-width:90px;
        font-weight: 500;
    }
    .font14{
        font-size: 14px;
        color: grey;
        min-width:68px;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex_e{
        display: flex;
        justify-content: end;
    }
    .flex{
        display: flex;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 3px 9px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }

</style>
